import { useEffect, useRef, useState } from "react";

import { CONVEX_API_URL } from "../../../../config/config";

import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";

import "./styles.scss";
import { StaticImage } from "gatsby-plugin-image";
import Whatsapp from "./Whatsapp/whatsapp";

const KSLiveBanner = () => {
  const [activeEvents, setActiveEvents] = useState([]);

  useEffect(() => {
    fetchActiveEvents();
  }, []);

  const fetchActiveEvents = async () => {
    try {
      const url = `${CONVEX_API_URL}/program/null/campaign/null/events/latest-events`;

      const res = await fetch(url);
      const data = await res.json();

      if (res.ok && res.status === 200) setActiveEvents(data);
    } catch (error) {
      console.log(error);
    }
  };

  if (!activeEvents.length) {
    //fff
    return null;
  }

  return (
    <section className="ks-live-banner-main">
      <div className="ks-live-banner-header-container">
        <h3 className="sub-header">
          Kraftshala Live: 1,00,000+ Learners Attended
        </h3>
        <h1 className="main-header">
          Begin your upskilling journey <br />
          <span className="highlight">1 FREE Session at a time.</span>
        </h1>
      </div>
      <KSLiveBannerCard isHomepage={true} activeEvents={activeEvents} />
    </section>
  );
};

export const KSLiveBannerCard = ({
  onClickOutside,
  activeEvents,
  isHomepage,
  isPopup = false,
  ...other
}) => {
  const {
    id,
    title,
    description,
    start_date_time,
    desk_popup_banner,
    mob_popup_banner,
  } = activeEvents?.[0] ?? {};

  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  const eventDate =
    moment(start_date_time).format("D") +
    " " +
    moment(start_date_time).format("MMM");
  const eventTime = moment(start_date_time).format("LT");

  const [showThankyouMsg, setThankyouMsgVisibility] = useState(false);

  const handleReserveSeat = () => {
    if (typeof window) {
      const redirectURL = `/kraftshala-live/register/${id}?home_page=true${window.location.search}`;
      window.open(redirectURL, "_blank");
    }
  };

  const handleThankyouMsgVisibility = () => {
    setThankyouMsgVisibility(!showThankyouMsg);
  };

  const SessionInfoConatiner = () => {
    return (
      <div className="ks-live-session-info" ref={ref}>
        {other?.children ?? null}
        <h2 className="banner-card-header">{title ?? ""}</h2>
        <img
          src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oxgfpr.png"
          loading="lazy"
          className="underline-img"
        />
        <p className="ks-live-session-about">{description ?? ""}</p>
        <div className="session-timings">
          <div className="session-date">
            <span>Event date</span>
            <span className="date-hl">{eventDate ?? ""}</span>
          </div>
          <div className="session-time">
            <span>Time</span>
            <span className="time-hl">{eventTime ?? ""}</span>
          </div>
        </div>
        {!isPopup && (
          <button className="reserve-seat-btn" onClick={handleReserveSeat}>
            Reserve my seat
          </button>
        )}
        {isPopup && (
          <KSLiveEnrollForm
            activeEvents={activeEvents}
            // showThankyouMsg={showThankyouMsg}
            handleThankyouMsgVisibility={handleThankyouMsgVisibility}
          />
        )}
      </div>
    );
  };

  return (
    <div className="ks-live-banner-card">
      <KSLiveSpeakerCard
        deskBanner={desk_popup_banner}
        mobBanner={mob_popup_banner}
      />
      {!showThankyouMsg && <SessionInfoConatiner />}
      {showThankyouMsg && (
        <ThankyouConatiner activeEvents={activeEvents} {...other} />
      )}
      <img
        src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oxe7gc.png"
        alt="ks live logo"
        className="ks-live-logo"
      />
    </div>
  );
};

const KSLiveSpeakerCard = ({ deskBanner, mobBanner }) => {
  const matches = useMediaQuery(`(max-width: 800px)`);

  return (
    <div className="ks-live-speaker-card">
      {/* <div className="speaker-img"> */}
      <img
        src={!matches ? deskBanner : mobBanner}
        alt="Speaker Photo"
        loading="lazy"
        className="speaker-img"
      />
      {/* </div> */}
    </div>
  );
};

const KSLiveEnrollForm = ({ activeEvents, handleThankyouMsgVisibility }) => {
  const { id } = activeEvents?.[0] ?? {};

  const [formFields, setFormFields] = useState({
    name: "",
    email: "",
    phone: "",
    opt_in: "",
  });
  const errorInit = {
    general: false,
    email: false,
    phone: false,
  };
  const [showError, setShowError] = useState(errorInit);
  const [isLoading, setLoading] = useState(false);

  const handleFormFieldChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  const validateFields = (e) => {
    e.preventDefault();
    let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let phonePattern = /^\d{10}$/;

    let isEmailValid = emailPattern.test(formFields.email);
    let isPhoneValid = phonePattern.test(formFields.phone);

    setShowError({
      ...showError,
      email: !isEmailValid,
      phone: !isPhoneValid,
    });

    if (!isEmailValid || !isPhoneValid) return;

    handleReserveSeat();
  };

  const handleReserveSeat = async () => {
    try {
      setLoading(true);
      setShowError(errorInit);
      let leadData = {
        email: formFields.email,
        phone: formFields.phone,
        name: formFields.name,
        whatsapp_consent: formFields.opt_in === "Yes" ? true : false,
        additional_details: {},
        event_details: activeEvents?.[0] ?? {},
        from_popup: true,
        source_page: window.location.href,
      };
      const url = `${CONVEX_API_URL}/program/null/campaign/null/events/${id}/lead`;

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(leadData),
      });
      const resData = await res.json();

      if (resData.message === "Invalid Email ID.") {
        setLoading(false);

        return null;
      }

      if (resData.message === "Lead already exists.") {
        setLoading(false);
        handleThankyouMsgVisibility();

        return null;
      }

      if (!res.ok || resData.status === 400) {
        throw resData?.message ?? "Something went wrong!";
      }

      setLoading(false);
      handleThankyouMsgVisibility();
    } catch (error) {
      console.error(error);
      setLoading(false);
      setShowError({
        ...showError,
        general: true,
      });
    }
  };

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();

  const handleDialogClose = () => {
    const contactUsDialog = document.querySelector("#ks-live-popup");

    if (contactUsDialog) {
      contactUsDialog.close();
    }
  };

  return (
    <div className="ks-live-enroll-container">
      <form onSubmit={validateFields} className="ks-live-enroll-form">
        <div className="input-fields">
          <div>
            <input
              onChange={handleFormFieldChange}
              type="text"
              className="form-field"
              placeholder="Name*"
              name="name"
              autoComplete="off"
              required
            />
            <span></span>
          </div>

          <div>
            <input
              onChange={handleFormFieldChange}
              type="text"
              className="form-field"
              placeholder="Email*"
              name="email"
              autoComplete="off"
              required
            />
            <span
              className="show-error"
              aria-hidden={(!showError.email).toString()}
            >
              Invalid Email
            </span>
          </div>

          <div>
            <input
              onChange={handleFormFieldChange}
              onKeyDown={blockInvalidChar}
              type="number"
              className="form-field"
              placeholder="Phone Number*"
              name="phone"
              autoComplete="off"
              required
            />
            <span
              className="show-error"
              aria-hidden={(!showError.phone).toString()}
            >
              Invalid Phone Number
            </span>
          </div>
        </div>

        <div className="slot-group" />
        <div className="whatsapp_optin">
          <label className="optin-container">
            {/* Send me the admission process & test details on Whatsapp */}
            <div className="wrapper-check">
              Get session details on *{" "}
              <StaticImage
                src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oy6cj2.webp"
                alt="whatsapp icon"
                className="whatsapp"
                placeholder="none"
              />
            </div>
          </label>

          <Whatsapp
            name="opt_in"
            handleFormFieldChange={handleFormFieldChange}
            //btnClicked={btnClicked}
            options={["Yes", "No"]}
            checkedValue={formFields.opt_in}
          />
        </div>

        <button
          className="reserve-seat-btn"
          // onClick={handleReserveSeat}
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Reserve my seat"}
        </button>
        <i className="already-reg-txt">
          If already registered, click{" "}
          <button className="action-btn" onClick={handleDialogClose}>
            here
          </button>
        </i>
      </form>
    </div>
  );
};

const ThankyouConatiner = ({ activeEvents, ...other }) => {
  const { title, start_date_time } = activeEvents?.[0] ?? {};

  const eventDate =
    moment(start_date_time).format("D") +
    " " +
    moment(start_date_time).format("MMM");
  const eventTime = moment(start_date_time).format("LT");

  const handleDialogClose = () => {
    const contactUsDialog = document.querySelector("#ks-live-popup");

    if (contactUsDialog) {
      contactUsDialog.close();
    }
  };

  return (
    <div className="ks-live-session-info">
      {other?.children ?? null}
      <h2 className="banner-card-header">
        Thank you for registering for
        <br /> this session
      </h2>
      <img
        src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oxgfpr.png"
        loading="lazy"
        className="underline-img"
      />
      <p className="ks-live-session-about">
        <b>“{title}”</b> session link will be sent to your registered email
        soon. See you there!
      </p>
      <div className="session-timings">
        <div className="session-date">
          <span>Event date</span>
          <span className="date-hl">{eventDate ?? ""}</span>
        </div>
        <div className="session-time">
          <span>Time</span>
          <span className="time-hl">{eventTime ?? ""}</span>
        </div>
      </div>
      <button className="okay-btn" onClick={handleDialogClose}>
        Okay
      </button>
    </div>
  );
};

export default KSLiveBanner;
